<template>
	<div class="newx_box">
		<common-top :commonTopData="commonTopData"></common-top>
		<nav-top :btns="btns" v-model="onNav"></nav-top>
		<component v-bind:is="onNav"></component>
	</div>
</template>
<script>
import commonTop from '@/components/commonTop.vue'
import navTop from './nav_top.vue'
import comNr from './com_nr.vue'
import comZt from './com_zt.vue'
export default {
	components: {
		commonTop,
		navTop,
		comNr,
		comZt
	},
	data () {
		return {
			commonTopData: {
				"commonleftbtn": [],
			},
			onNav:'comZt',
			btns:[
                {label:'专题列表',value:'comZt'},
                {label:'内容管理',value:'comNr'},
            ],
		}
	},
	created(){
		this.initFn();
	},
	methods:{
		initFn(){
			this.onNav = this.$route.query.tabs || 'comZt';
		}
	}
}
</script>
<style >
.newx_box{
	position: relative;
	height: 100%;
}
</style>

<style >
.container .el-tabs__header {
			margin: 0;
			    padding: 0;
    position: relative;
    margin: 0 0 15px;
    position: absolute;
    top: -72px;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
		}
</style>